export const EmailChallengedState = {
  REQUIRED: 'REQUIRED',
  CHALLENGED: 'CHALLENGED',
  EXPIRED: 'EXPIRED',
  FAILED: 'FAILED'
};
//# sourceMappingURL=models.js.map